<template>
  <div class="tour curated-tour" role="presentation">
    <header-mobile>
      <h3>{{ $t('message.viewNotes') }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <div class="description" role="presentation">
        <p>{{ $t("notes.description") }}</p>
      </div>
      <note-form />
      <note-list :notes="notes" />
    </main>
  </div>
</template>

<script>
import HeaderMobile from '@/components/HeaderMobile'
import NoteList from '@/components/note/NoteList'
import NoteForm from '@/components/note/NoteForm'
import { mapState } from 'vuex'

export default {
  name: 'Notes',
  components: {
    'header-mobile': HeaderMobile,
    'note-list': NoteList,
    'note-form': NoteForm
  },
  computed: mapState('student', ['notes'])
}
</script>
